import { useRef } from 'react'
import { useVirtualizer } from '@tanstack/react-virtual'

const DEFAULT_MAX_HEIGHT = '300px'
const ESTIMATED_ROW_HEIGHT = 30
const OVERSCAN = 10

function VirtualMenuList(props) {
  const { children, maxHeight = DEFAULT_MAX_HEIGHT } = props
  const parentRef = useRef(null)

  //If search does not return any results children is an object
  const isArray = Array.isArray(children)

  const rowVirtualizer = useVirtualizer({
    count: isArray ? children.length : 1,
    getScrollElement: () => parentRef.current,
    estimateSize: () => ESTIMATED_ROW_HEIGHT,
    getItemKey: (index) => children[index]?.key ?? index,
    overscan: OVERSCAN,
    enabled: true,
  })

  const editedChildrens = isArray
    ? children.map((child) => {
        if (child.props?.children && Array.isArray(child.props.children)) {
          child.props.children.forEach((child) => {
            if (child.props?.innerProps) {
              delete child.props.innerProps.onMouseMove //FIX LAG
              delete child.props.innerProps.onMouseOver //FIX LAG
            }
            return child
          })
        }
        return child
      })
    : [children]

  const rows = rowVirtualizer.getVirtualItems()

  return (
    <div ref={parentRef} style={{ height: maxHeight, overflowY: 'auto' }}>
      <div
        style={{
          height: `${rowVirtualizer.getTotalSize()}px`,
          position: 'relative',
          width: '100%',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            transform: `translateY(${rows[0]?.start ?? 0}px)`,
          }}
        >
          {rows.map((virtualRow) => (
            <div
              key={virtualRow.key}
              data-index={virtualRow.index}
              ref={rowVirtualizer.measureElement}
            >
              {editedChildrens[virtualRow.index]}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default VirtualMenuList
